import React from 'react';
import PropTypes from 'prop-types';
import { FULFILLMENT_METHODS } from '../../../constants';

const ShippingThreshold = ({
  type,
  hasFreeShipping,
  totalCharge,
  maxCartPriceContributor,
  selected,
  isCartTiles
}) => {
  const showMultiLineDeliveryFee = isCartTiles && maxCartPriceContributor && selected;
  const getMultiLineDeliveryPrice = () => {
    return <span className="sui-font-bold sui-text-succes">Included</span>;
  };

  const hasFreeShippingCondtions = [
    hasFreeShipping && type === FULFILLMENT_METHODS.APPLIANCE,
    !totalCharge && [FULFILLMENT_METHODS.STH_FFM, FULFILLMENT_METHODS.EXPRESS_DELIVERY].includes(type)
  ];

  if (hasFreeShippingCondtions.some((condition) => !!condition)) {
    return <span className="sui-font-bold sui-text-succes">FREE</span>;
  }

  if ([FULFILLMENT_METHODS.STH_FFM, FULFILLMENT_METHODS.EXPRESS_DELIVERY].includes(type)) {
    if (showMultiLineDeliveryFee) {
      return getMultiLineDeliveryPrice();
    }
  }

  // eslint-disable-next-line tailwindcss/no-arbitrary-value
  return <span className="sui-pt-2 sui-min-h-[24px]">&nbsp;</span>;
};

ShippingThreshold.propTypes = {
  type: PropTypes.string,
  hasFreeShipping: PropTypes.bool,
  totalCharge: PropTypes.number,
  maxCartPriceContributor: PropTypes.bool,
  selected: PropTypes.bool,
  isCartTiles: PropTypes.bool
};

ShippingThreshold.defaultProps = {
  type: null,
  hasFreeShipping: false,
  totalCharge: null,
  maxCartPriceContributor: false,
  selected: false,
  isCartTiles: false
};

export { ShippingThreshold };